import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { Flex, Card } from '../design-system';
import styled from 'styled-components';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Dashboard from '../containers/Dashboard';
import Clients from '../containers/Clients';
import ClientEdit from '../containers/Clients/edit';
import Projects from '../containers/Projects';
import ProjectEdit from '../containers/Projects/edit';
import Funders from '../containers/Funders';
import FunderEdit from '../containers/Funders/edit';
import Vault from '../containers/Vault';
import Deadlines from '../containers/Deadlines';
import Reports from '../containers/Reports';
import Account from '../containers/Account';
import Admin from '../containers/Admin';
import Contacts from '../containers/Contacts';
import FirstWelcome from '../containers/FirstWelcome';
import PermissionRoute from './route';
import { PERMISSIONS } from '../globalConstants';
import AgencyEdit from '../containers/Admin/Agency';
import ContactEdit from '../containers/Contacts/edit';
import OrgSearch from '../containers/OrgSearch';
const StyledBox = styled(Flex)`
  flex-flow: column;
  width: 100%;
`;

const StyledCard = styled(Card)`
  background-color: ${(p) => p.theme.colors.greyLightest};
  border-radius: 0;
  flex-grow: 1;
`;

interface AuthedRoutesProps {
  user: import('../types').User;
  route_to: string | null;
}

const AuthedRoutes = ({ user, route_to }: AuthedRoutesProps) => (
  <>
    <Sidebar />
    <StyledBox>
      <Header />
      <StyledCard>
        <Routes>
          <Route
            path="/account/*"
            element={
              <PermissionRoute
                component={Account}
                allowedPermissions={PERMISSIONS.READ_PROFILE}
              />
            }
          />
          {user.agency && user.agency.plan_id !== 1 && (
            <Route
              path="/vault/*"
              element={
                <PermissionRoute
                  component={Vault}
                  allowedPermissions={PERMISSIONS.READ_VAULT}
                />
              }
            />
          )}
          <Route
            path="/reports"
            element={<PermissionRoute component={Reports} />}
          />
          <Route
            path="/deadlines"
            element={
              <PermissionRoute
                component={Deadlines}
                allowedPermissions={PERMISSIONS.READ_DEADLINES}
              />
            }
          />
          <Route
            path="/funders/edit/:id"
            element={
              <PermissionRoute
                component={FunderEdit}
                allowedPermissions={PERMISSIONS.READ_FUNDERS}
              />
            }
          />
          <Route
            path="/funders"
            element={
              <PermissionRoute
                component={Funders}
                allowedPermissions={PERMISSIONS.READ_FUNDERS}
              />
            }
          />
          <Route
            path="/projects/edit/:id"
            element={
              <PermissionRoute
                component={ProjectEdit}
                allowedPermissions={PERMISSIONS.READ_PROJECTS}
              />
            }
          />
          <Route
            path="/projects"
            element={
              <PermissionRoute
                component={Projects}
                allowedPermissions={PERMISSIONS.READ_PROJECTS}
              />
            }
          />
          <Route
            path="/clients/edit/:id"
            element={
              <PermissionRoute
                component={ClientEdit}
                allowedPermissions={PERMISSIONS.READ_CLIENTS}
              />
            }
          />
          <Route
            path="/clients"
            element={
              <PermissionRoute
                component={Clients}
                allowedPermissions={PERMISSIONS.READ_CLIENTS}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <PermissionRoute
                component={Dashboard}
                allowedPermissions={PERMISSIONS.READ_DASHBOARD}
              />
            }
          />
          <Route
            path="/administration/agency/:id"
            element={
              <PermissionRoute
                component={AgencyEdit}
                allowedPermissions={PERMISSIONS.SUPER_ADMIN}
              />
            }
          />
          <Route
            path="/administration/*"
            element={
              <PermissionRoute
                component={Admin}
                allowedPermissions={PERMISSIONS.SUPER_ADMIN}
              />
            }
          />
          <Route
            path="/contacts/edit/:id"
            element={
              <PermissionRoute
                component={ContactEdit}
                allowedPermissions={PERMISSIONS.READ_CONTACT}
              />
            }
          />
          <Route
            path="/contacts"
            element={
              <PermissionRoute
                component={Contacts}
                allowedPermissions={PERMISSIONS.READ_CONTACT}
              />
            }
          />
          <Route
            path="/welcome"
            element={
              <PermissionRoute
                component={FirstWelcome}
                allowedPermissions={PERMISSIONS.READ_CONTACT}
              />
            }
          />
          <Route
            path="/foundations"
            element={
              <PermissionRoute
                component={OrgSearch}
                allowedPermissions={PERMISSIONS.READ_CONTACT}
              />
            }
          />
          {user.isFirstTime && (
            <Route path="*" element={<Navigate to="/welcome" replace />} />
          )}
          {!user.isFirstTime && (
            <Route
              path="*"
              element={
                <Navigate to={route_to ? route_to : '/dashboard'} replace />
              }
            />
          )}
        </Routes>
      </StyledCard>
    </StyledBox>
  </>
);

export default AuthedRoutes;
